import styled from "styled-components";
const Transition = styled.div`
  transition: ${props => (props.transition ? "opacity 750ms linear" : "none")};
`;

Transition.displayName = `Transition`;

export { Transition };
